angular.module('unica_approvation_list.approvation_list_controllers')

.controller('ApprovationListListAmController',
	function(
		$rootScope, $scope, $state, $stateParams,
		ApprovationListListService
	) {

	$scope.approvationLists = [];

	$scope.loadApprovationLists = function() {
		$scope.showLoader();

		ApprovationListListService
			.listAm( $rootScope.currentUser.id )
			.then(function(data) {
				$scope.hideLoader();

				if ( !data.error ) {

					for ( var i = 0; i < data.length; i++ ) {
						if ( !data[i].invitation_list.all_stage ) {
							data[i].invitation_list.stage.from_date = moment.unix( data[i].invitation_list.stage.from_date ).toDate();
							data[i].invitation_list.stage.from_time = data[i].invitation_list.stage.from_date;
							data[i].invitation_list.stage.to_date   = moment.unix( data[i].invitation_list.stage.to_date ).toDate();
							data[i].invitation_list.stage.to_time   = data[i].invitation_list.stage.to_date;
						}
					}

					$scope.approvationLists = $scope.approvationLists.concat( data );
				} else {
					$rootScope.manageError(data);
				}
			});
	};

	$scope.loadApprovationLists();

});
